import {
    CREATE_ALL_OVER_PRINTING_DC_FAILURE,
    CREATE_ALL_OVER_PRINTING_DC_REQUEST,
    CREATE_ALL_OVER_PRINTING_DC_SUCCESS,
    CREATE_USER_FORM_ALL_OVER_PRINTING_DC,
    FETCH_SINGLE_ALL_OVER_PRINTING_DC_FAILURE,
    FETCH_SINGLE_ALL_OVER_PRINTING_DC_REQUEST,
    FETCH_SINGLE_ALL_OVER_PRINTING_DC_SUCCESS,
    FETCH_ALL_OVER_PRINTING_DC_FAILURE,
    FETCH_ALL_OVER_PRINTING_DC_REQUEST,
    FETCH_ALL_OVER_PRINTING_DC_SUCCESS,
    NAVIGATE_ALL_OVER_PRINTING_DC_DETAILS,
    NAVIGATE_ALL_OVER_PRINTING_DC,
    ALL_OVER_PRINTING_DC_USERFORM_RESET,
    UPDATE_ALL_OVER_PRINTING_DC_FAILURE,
    UPDATE_ALL_OVER_PRINTING_DC_REQUEST,
    UPDATE_ALL_OVER_PRINTING_DC_SUCCESS,
    DELETE_ALL_OVER_PRINTING_DC_REQUEST,
    DELETE_ALL_OVER_PRINTING_DC_SUCCESS,
    DELETE_ALL_OVER_PRINTING_DC_FAILURE,
    ALL_OVER_PRINTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB,
    ALL_OVER_PRINTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE,
    FETCH_ALL_OVER_PRINTING_DC_STYLE_REQUEST,
    FETCH_ALL_OVER_PRINTING_DC_STYLE_SUCCESS,
    FETCH_ALL_OVER_PRINTING_DC_STYLE_FAILURE,
    FETCH_ALL_OVER_PRINTING_DC_INVOICE_REQUEST,
    FETCH_ALL_OVER_PRINTING_DC_INVOICE_SUCCESS,
    FETCH_ALL_OVER_PRINTING_DC_INVOICE_FAILURE,
    RESET_ALL_OVER_PRINTING_DC_INVOICE,
    HEADER_SEARCH_CALL_ONLOAD,
    NAVIGATE_ALL_OVER_PRINTING_PRINT
} from './printingDC.actionsType';

export const ALL_OVER_PRINTING_DC = 'AllOverPrintingDc';

let initialState = {
    loading: false,
    printingDC: [],
    printingDCInvoice: [],
    printingDCStyle: [],
    userform: {
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldIsInHouseDelivery: true,
        fldIsInHouseProduction: false,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldGrandTotalValue: 0,
        fldRoundoff: 0,
        fldIsReprocess: false,
        fldIsWithCost: false,
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date(),
        unitId: 1
    },
    selectedPrintingDC: {},
    detailsId: '',
    activeKey: 1,
    isPrintingDC: false,
    printingDCSelectedValue: null,
    errorMessage: '',
    iperrorMessage: '',
    headerSearchCall: true,
};

export let allOverPrintingDcReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_ALL_OVER_PRINTING_DC_REQUEST:
        case FETCH_ALL_OVER_PRINTING_DC_INVOICE_REQUEST:
        case FETCH_ALL_OVER_PRINTING_DC_STYLE_REQUEST:
        case CREATE_ALL_OVER_PRINTING_DC_REQUEST:
        case FETCH_SINGLE_ALL_OVER_PRINTING_DC_REQUEST:
        case UPDATE_ALL_OVER_PRINTING_DC_REQUEST:
        case DELETE_ALL_OVER_PRINTING_DC_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_ALL_OVER_PRINTING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDC: updatePayload
            };
        case HEADER_SEARCH_CALL_ONLOAD:
            return {
                ...state,
                loading: false,
                headerSearchCall: payload
            }
        case FETCH_ALL_OVER_PRINTING_DC_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDCInvoice: updatePayload
            };
        case FETCH_ALL_OVER_PRINTING_DC_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDCStyle: updatePayload?.PONO
            };
        case CREATE_ALL_OVER_PRINTING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: true,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: updatePayload
            };
        case FETCH_SINGLE_ALL_OVER_PRINTING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedPrintingDC: updatePayload,
                userform: {
                    ...updatePayload,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                }
            };
        case UPDATE_ALL_OVER_PRINTING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedPrintingDC: {},
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: true,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: ''
            };
        case DELETE_ALL_OVER_PRINTING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: true,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: '',
                selectedPrintingDC: {}
            };
        case FETCH_ALL_OVER_PRINTING_DC_FAILURE:
        case FETCH_ALL_OVER_PRINTING_DC_INVOICE_FAILURE:
        case FETCH_ALL_OVER_PRINTING_DC_STYLE_FAILURE:
        case FETCH_SINGLE_ALL_OVER_PRINTING_DC_FAILURE:
        case CREATE_ALL_OVER_PRINTING_DC_FAILURE:
        case UPDATE_ALL_OVER_PRINTING_DC_FAILURE:
        case DELETE_ALL_OVER_PRINTING_DC_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_ALL_OVER_PRINTING_DC:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case RESET_ALL_OVER_PRINTING_DC_INVOICE:
            return {
                ...state,
                printingDCInvoice: []
            };
        case ALL_OVER_PRINTING_DC_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: true,
                    fldIsInHouseProduction: false,
                    fldIsReprocess: false,
                    fldIsWithCost: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                selectedPrintingDC: {},
                detailsId: '',
                activeKey: 1
            };
        case NAVIGATE_ALL_OVER_PRINTING_DC_DETAILS:
            return {
                ...state,
                isPrintingDC: true,
                printingDCSelectedValue: updatePayload.printingDCSelectedValue
            };
        case NAVIGATE_ALL_OVER_PRINTING_DC:
            return {
                ...state,
                isPrintingDC: false
            };
        case NAVIGATE_ALL_OVER_PRINTING_PRINT:
            return {
                ...state,
                isPrintingDC: false,
                printingDCSelectedValue: updatePayload.printingDCSelectedValue
            }
        case ALL_OVER_PRINTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: true,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                activeKey: 2
            };
        case ALL_OVER_PRINTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: true,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                activeKey: 1
            };
        default:
            return state;
    }
};
